module.exports = __webpack_public_path__ + "img/quiz.ab39985c.png";